<template>
  <div class="filters__optional-wrapper">
    <section class="filters__optional">
      <FiltersCategory
        categoryTitle="Gender"
        :filters="genders"
        :removeFilterFromButton="removeFilterFromButton"
        :selectedFilters="selectedGenders"
        :updateFilterFromButton="updateFilterFromButton"
      ></FiltersCategory>
      <FiltersCategory
        categoryTitle="Spoken languages"
        :filters="languages"
        :removeFilterFromButton="removeFilterFromButton"
        :selectedFilters="selectedLanguages"
        :updateFilterFromButton="updateFilterFromButton"
      ></FiltersCategory>
      <FiltersCategory
        categoryTitle="Cultural expertise"
        :filters="culturalExperience"
        :removeFilterFromButton="removeFilterFromButton"
        :selectedFilters="selectedCulturalExperience"
        :updateFilterFromButton="updateFilterFromButton"
      ></FiltersCategory>
      <FiltersCategory
        categoryTitle="Therapist expertise"
        :filters="therapistExperience"
        :removeFilterFromButton="removeFilterFromButton"
        :selectedFilters="selectedTherapistExperience"
        :updateFilterFromButton="updateFilterFromButton"
      ></FiltersCategory>
    </section>
    <section>
      <FiltersFooter
        :APICall="APICall"
        :applyFiltersText="applyFiltersText"
        :applyFiltersToAPICall="applyFiltersToAPICall"
        :clearFiltersText="clearFiltersText"
        :clearAllFilters="clearAllFilters"
        :updateShowOptions="updateShowOptions"
      ></FiltersFooter>
    </section>
  </div>
</template>

<script>
import Vue from "vue";
import FiltersCategory from "./FiltersCategory.vue";
import FiltersFooter from "./FiltersFooter.vue";

export default Vue.component("FiltersOptional", {
  props: {
    APICall: Function,
    applyFiltersText: String,
    applyFiltersToAPICall: Function,
    clearAllFilters: Function,
    clearFiltersText: String,
    culturalExperience: Array,
    genders: Array,
    languages: Array,
    optionalExpanded: Boolean,
    removeFilterFromButton: Function,
    selectedCulturalExperience: Array,
    selectedGenders: Array,
    selectedLanguages: Array,
    selectedTherapistExperience: Array,
    therapistExperience: Array,
    updateFilterFromButton: Function,
    updateShowOptions: Function,
  },
  components: {
    FiltersCategory,
    FiltersFooter,
  },
});
</script>
